import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IModule } from "../components/GestionFonctionnalite/Module/moduleSlice";



export interface IUserState {
  typeUtilisateurs: ITypeUtilisateur[];
  utilisateurs: IUtilisateur[];
  userConnected: IUserConnected | null;

}



export interface IUserConnected {
  userRights: string[];
  user: IUtilisateur;
}

export interface ITypeUtilisateur {
  idTypeUtilisateur: number;
  libTypeUtilisateur: string;
}

export interface IUtilisateur {
  idUtilisateur: number;
  idTypeUtilisateur: number;
  nomUtilisateur: string;
  motDePasse?: string;
  motDePasseInitial?: string;
  statusUtilisateur?: number;
}

const initialState: IUserState = {
  typeUtilisateurs: [],
  utilisateurs: [],
  userConnected: null

}

export const userSlice = createSlice({
  name: "users",
  initialState: initialState,

  reducers: {
    setTypeUtilisateur: (state, action: PayloadAction<ITypeUtilisateur[]>) => {
      state.typeUtilisateurs = action.payload;
    },

    setUtilisateur: (state, action: PayloadAction<IUtilisateur[]>) => {
      state.utilisateurs = action.payload;
    },

    setUserConnected: (state, action: PayloadAction<IUserConnected>) => {
      state.userConnected = action.payload;
    },

  },
});

export const {setUserConnected, setTypeUtilisateur,setUtilisateur } = userSlice.actions;

export default userSlice.reducer;
